/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconZodiacSagittarius = createReactComponent(
  "zodiac-sagittarius",
  "IconZodiacSagittarius",
  [
    ["path", { d: "M4 20l16 -16", key: "svg-0" }],
    ["path", { d: "M13 4h7v7", key: "svg-1" }],
    ["path", { d: "M6.5 12.5l5 5", key: "svg-2" }]
  ]
);

export { IconZodiacSagittarius as default };
//# sourceMappingURL=IconZodiacSagittarius.js.map
